import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { LocalDataSource, ServerDataSource } from "ng2-smart-table";
import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';

@Component({
  selector: 'ngx-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

@Injectable({
  providedIn: 'root'
})

export class HomeComponent implements OnInit {

  dataList = []
  Source: LocalDataSource ;

  //基本資料
  ORG_Company_ID: number;
  ORG_Store_ID: number;

  cntractRd:string;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,

  ) { 
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'));
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.ORG_Store_ID = (cookie_sid && cookie_sid != '') ? parseInt(cookie_sid) : null
  }


  ngOnInit(): void {
    this.GetMainList();

    let PerPage = 10
    this.Source = new LocalDataSource();
    this.Source.setPaging(1,PerPage,false)

    this.GetContractRd();
  }


  onPage(v){
    console.log('page',v)
    this.GetMainList()
  }

  GetMainList(){
    let perPage = 10
    let page = 1;
    if (this.Source && this.Source.getPaging()) {
      let pagingConf  = this.Source.getPaging();
      page = pagingConf.page
      perPage = pagingConf.perPage
    }

    console.log("第幾頁",page)

    this.http.get<any>("api/News/GetNews?"+ 
    "Page="+page+
    "&PerPage="+perPage+
    "&IsDelete=true").subscribe({
      next: (data) => {
        if (data.RESULT != null && data.RESULT != "") {
          alert(data.RESULT);
        } else {
          this.dataList = data.LIST

          if(!this.dataList)
            this.dataList=[]


          this.dataList.forEach(x=>{
            if(x.StoreList){
              x.StoreShow = x.StoreList.map(x=>x.StoreName).join("、")
            }              
          })

          this.Source.load(new Array(data.Total));
          
         
        }
      },
      error: (error) => {},
    });

  }

  GetContractRd(){
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    let sid = (cookie_sid && cookie_sid!='') ? parseInt(cookie_sid) : null 
    this.http.post<any>('api/Contract/ContractRemind',{
      ORG_Company_ID: this.ORG_Company_ID,
      ORG_Store_ID: sid == 0 ? null : sid,
    }).subscribe({
      next: data=> {
        console.log( data.TipContant);
        let my = document.getElementById('contract');
        let mytext = document.getElementById('contracttext');
        if(data.TipContant){
        mytext.innerHTML= '合約提醒：<br>'+data.TipContant;
          my.style.display='flex';
        }else{
          my.style.display='none';

        }
      },
      error: error => {
        console.error('There was an error!', error);
      }
    },
    )};
  

  

}
